/**
 *
 * @param {T: null | undefined} value
 * @returns {value is T: null | undefined}
 */
export function isDefined(value: unknown): boolean {
  return value !== null && value !== undefined;
}

export function assertNotNull<Type>(input: Type | null): Type {
  if (input !== null) {
    return input;
  }
  throw new Error("Null check failed");
}
